import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Dropdown, message } from "antd";
import Sortable from "sortablejs";
import { useSelector } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";

import Targetrolescard from "./Targetrolescard";
import Targetindustriescard from "./Targetindustries";
import Timeline from "./Timeline";
import MyTasks from "./MyTasks";
import Calendar from "../Calendar";
import { selectProfile } from "slices/dashboardSlice";

import ProfessionalSumary from "./professionalSumary";
import ShortTermGoals from "./ShortTermGoals";
import UpcomingMeetings from "./UpcomingMeetings";
import Targetworkenvironmentcard from "./Targetworkenvironmentcard";
// import searchClose from "../../Assets/searchclose.png";
import DASHBOARD_API from "api/dashboard"; // Import API helper
import HELPERS from "utils/helper";
import CoachSummary from "./CoachSummary";

const componentMap = {
  coach_summary: <CoachSummary />,
  target_roles: <Targetrolescard />,
  target_industries: <Targetindustriescard />,
  timeline: <Timeline />,
  short_term_goals: <ShortTermGoals />,
  professional_summary: <ProfessionalSumary />,
  upcoming_meetings: <UpcomingMeetings />,
  target_work_environment: <Targetworkenvironmentcard />,
  my_tasks: <MyTasks />,
  calendar: <Calendar />,
};

const userId = HELPERS.getUserId();

const fetchApiResponse = {
    "coach_summary": { "id": "coach_summary", "key": "coach_summary", "label": "Coach Summary", "span": 24, "position": 0 },
    "target_roles": { "id": "target_roles", "key": "target_roles", "label": "Target Roles", "span": 12, "position": 1 },
    "target_industries": { "id": "target_industries", "key": "target_industries", "label": "Target Industries", "span": 12, "position": 2 },
    "timeline": { "id": "timeline", "key": "timeline", "label": "Timeline", "span": 24, "position": 3 },
    "short_term_goals": { "id": "short_term_goals", "key": "short_term_goals", "label": "Short Term Goals", "span": 24, "position": 4 },
    "professional_summary": { "id": "professional_summary", "key": "professional_summary", "label": "Professional Summary", "span": 12, "position": 5 },
    "upcoming_meetings": { "id": "upcoming_meetings", "key": "upcoming_meetings", "label": "Upcoming Meetings", "span": 12, "position": 6 },
    "target_work_environment": { "id": "target_work_environment", "key": "target_work_environment", "label": "Target Work Environment", "span": 12, "position": 7 },
    "my_tasks": { "id": "my_tasks", "key": "my_tasks", "label": "My Tasks", "span": 12, "position": 0 },
    "calendar": { "id": "calendar", "key": "calendar", "label": "Calendar", "span": 12, "position": 1 },
}

// console.log('sss userID', userId, fetchApiResponse);

const WelcomeMessage = () => {
  const profile = useSelector(selectProfile);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        boxShadow: "0px 4px 20px 0px #0000000F",
        alignItems: "center",
        height: "72px",
      }}
    >
    <div
      style={{
        fontSize: "20px",
        fontWeight: '800',
        color: "#111111",
        textAlign: "left",
        padding: "2% 1%",
        fontFamily:'AvenirBook',
        width: 'fit-content',
        lineHeight: "27.32px",
      }}
      >
      Welcome, {profile ? profile.first_name : "User"}!
    </div>
    <div
    style={{
      fontSize: 30,
      color: "#111111",
      textAlign: "left",
      padding: "2% 1%",
      width: 'fit-content',
    }}
    > 
    </div>
    </div>
  );
};

const DashboardComp = (props) => {

  const [leftSections, setLeftSections] = useState([]);
  const [rightSections, setRightSections] = useState([]);
  // console.log('sss leftSections', leftSections, 'sss rightSections', rightSections)
  const leftContainerRef = useRef(null);
  const rightContainerRef = useRef(null);
  // console.log('sss props', props)

  // ✅ Fetch saved positions from API
  const fetchPositions = async () => {
    try {
      console.log("fetch");
      const response = await DASHBOARD_API.getDashboardItems(userId);
      // console.log("sss fetch api response", response.data);
      if (response.data) {
        setLeftSections(
          response.data.left.map((section, index) => ({
            ...section,
            component: componentMap[section.key],
            position: index,
          }))
        );
        setRightSections(
          response.data.right.map((section, index) => ({
            ...section,
            component: componentMap[section.key],
            position: index,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching dashboard positions:", error);
    }
  };
  useEffect(() => {
    fetchPositions();
  }, []);

  // ✅ Function to update the API when components are moved
  const updateDashboardState = async (left, right, prevLeft, prevRight) => {
    // console.log("sss", left, right, prevLeft, prevRight)
    try {
      // ✅ Ensure inputs are valid arrays
      console.log("update");
      left = Array.isArray(left) ? left : [];
      right = Array.isArray(right) ? right : [];
      prevLeft = Array.isArray(prevLeft) ? prevLeft : [];
      prevRight = Array.isArray(prevRight) ? prevRight : [];

      // ✅ Assign updated positions
      const updatedLeft = left.map(({ component, ...item }, index) => ({
        ...item,
        position: index,
      }));
      const updatedRight = right.map(({ component, ...item }, index) => ({
        ...item,
        position: index,
      }));

      const updateApiPayload = {"left": updatedLeft, "right": updatedRight, "userId": userId}

      console.log("sss Sent only updated & new items:", updateApiPayload, updatedLeft, updatedRight);

      // ✅ Send only updated & newly added items to API
      await DASHBOARD_API.updateDashboardItems({ updateApiPayload })
      .then((response) => {
        console.log("sss patch api response", response);
        message.success("Your work has been saved")
      })
      .catch((err) => {
        console.log("sss patch api error", err);
        message.error("Your work has not been saved")
      });
    } catch (error) {
      console.error("Error updating dashboard positions:", error);
    }
  };

  // ✅ Function to delete a component
  const handleDelete = async (id, setSections) => {
    // ✅ Remove from dashboard state ONLY
    console.log("delete");
    setSections((prev) => prev.filter((section) => section.id !== id));

    try {
      const payload = { "step_id": id, "user_id": userId }
      await DASHBOARD_API.deleteDashboardItem(payload)
      .then((response) => {
        console.log("sss delete api response", response);
      })
      .catch((err) => {
        console.log("sss delete api error", err, payload);
      });
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const createSortable = (containerRef) => {
    return new Sortable(containerRef.current, {
      animation: 150,
      group: { name: "shared_dash", pull: true, put: true },
      // group: { name: "shared_dash", pull: false, put: true }, // disable left-to-right and right-to-left swap
      swapThreshold: 0.65,
      handle: ".drag-handle",
      
      onStart: (evt) => {
        evt.item.__originalParent = evt.from || null; // Store original parent
      },

      onAdd: (evt) => {
        const newItemKey = evt.item.dataset.key;
        const existingItemId = evt.item.dataset.id;
        const existingItemlabel = evt.item.dataset.label;
        const isFromCustomizeDash = evt.item.getAttribute("data-source") === "customizeDash";
        const isMovingToRight = evt.to === rightContainerRef.current;
        const isMovingToLeft = evt.to === leftContainerRef.current;
        
        if (!componentMap[newItemKey]) {
          console.error(`Component for key "${newItemKey}" not found.`);
          return;
        }
        
        let updatedLeftSections = [...leftSections];
        let updatedRightSections = [...rightSections];
        
        if (isFromCustomizeDash) {
          console.log("sss hi fromDropdown")
          const originalItem = leftSections.find(item => item.key === newItemKey) 
          || rightSections.find(item => item.key === newItemKey);
          const newSection = {
            id: `${newItemKey}_${Date.now()}`,
            key: newItemKey,
            component: componentMap[newItemKey], // ✅ Only render the component
            // span: originalItem?.span || 24,
            span: fetchApiResponse[newItemKey].span,
            position: isMovingToLeft
            ? updatedLeftSections.length
            : updatedRightSections.length,
          };
          
          console.log({ newSection });
          
          if (isMovingToLeft) {
            updatedLeftSections.splice(evt.newIndex, 0, newSection);
            setLeftSections(updatedLeftSections);
          } else if (isMovingToRight) {
            updatedRightSections.splice(evt.newIndex, 0, newSection);
            setRightSections(updatedRightSections);
          }
          setTimeout(() => {
            if (evt.item && evt.item.parentNode === evt.to && evt.item.getAttribute("data-source") === "customizeDash") {
              evt.to.removeChild(evt.item);
            }
          }, 50);
        } else if (isMovingToRight) {
          console.log("sss hi right", newItemKey)
          updatedLeftSections = updatedLeftSections.filter(
            (item) => item.id !== existingItemId
          );
          if (
            !updatedRightSections.some((item) => item.id === existingItemId)
          ) {
            updatedRightSections = [
              ...updatedRightSections.slice(0, evt.newIndex),
              {
                id: existingItemId,
                key: newItemKey,
                component: componentMap[newItemKey],
                // span: 24,
                span: fetchApiResponse[newItemKey].span,
                position: evt.newIndex,
                label: existingItemlabel,
              },
              ...updatedRightSections.slice(evt.newIndex),
            ];
          }
        } else if (isMovingToLeft) {
          console.log("sss hi left")
          updatedRightSections = updatedRightSections.filter(
            (item) => item.id !== existingItemId
          );
          if (
            !updatedLeftSections.some((item) => item.id === existingItemId)
          ) {
            updatedLeftSections = [
              ...updatedLeftSections.slice(0, evt.newIndex),
              {
                id: existingItemId,
                key: newItemKey,
                component: componentMap[newItemKey],
                // span: 24,
                span: fetchApiResponse[newItemKey].span,
                position: evt.newIndex,
                label: existingItemlabel,
              },
              ...updatedLeftSections.slice(evt.newIndex),
            ];
          }
        }
        
        setTimeout(() => {
          updateDashboardState(updatedLeftSections, updatedRightSections, leftSections, rightSections);
        }, 100);
      },
      onUpdate: (evt) => {
        console.log('this is useEffect in DashboardComp file update', containerRef.current)
        const existingItemId = evt.item.dataset.id;
        const existingItemlabel = evt.item.dataset.label;
        const isInLeftSection = evt.from === leftContainerRef.current;
        const isInRightSection = evt.from === rightContainerRef.current;
        
        console.log("onUpdate triggered"); // ✅ Debugging log
      
        let updatedLeftSections = [...leftSections];
        let updatedRightSections = [...rightSections];
        
        if (isInLeftSection) {
          console.log("Reordering in left section");
          const movedItemIndex = updatedLeftSections.findIndex((item) => item.id === existingItemId);
          if (movedItemIndex !== -1) {
            const [movedItem] = updatedLeftSections.splice(movedItemIndex, 1);
            movedItem.position = evt.newIndex;
            updatedLeftSections.splice(evt.newIndex, 0, movedItem);
          }
          setLeftSections(updatedLeftSections);
        } else if (isInRightSection) {
          console.log("Reordering in right section");
          const movedItemIndex = updatedRightSections.findIndex((item) => item.id === existingItemId);
          if (movedItemIndex !== -1) {
            const [movedItem] = updatedRightSections.splice(movedItemIndex, 1);
            movedItem.position = evt.newIndex;
            updatedRightSections.splice(evt.newIndex, 0, movedItem);
          }
          setRightSections(updatedRightSections);
        }
      
        setTimeout(() => {
          updateDashboardState(updatedLeftSections, updatedRightSections, leftSections, rightSections);
        }, 100);
      },
      
    });
  };

  useEffect(() => {
    const rightSortable = createSortable(rightContainerRef);
    const leftSortable = createSortable(leftContainerRef);
    return () => {
      rightSortable.destroy();
      leftSortable.destroy();
    };
  }, [rightSections, leftSections]);

  const handleDragStart = (e, item) => {
    e.stopPropagation(); // Prevent event bubbling
    e.dataTransfer.setData("text/plain", JSON.stringify(item));
    e.dataTransfer.effectAllowed = "move";
  };

  const handleMouseDown = (e) => {
    e.stopPropagation(); // Prevent unwanted drag behavior
  };

  const highlightedKeys = [
  "target_work_environment",
  "target_industries",
  "target_roles",
  "upcoming_meetings"
];

  return (
    <div>
      <Row 
        // gutter={[16, 16]}
      >
        <Col span={16}>
          <Row
            // gutter={[16, 16]}
            ref={leftContainerRef}
            className="leftside sortable-container"
          >
            {leftSections.map((item) => (
              <Col
                key={item.id}
                data-id={item.id}
                data-key={item.key}
                data-label={item.label}
                span={item.span}
                className="leftside sortable-item"
                style={{
                  margin: "20px 0",
                }}
              >
                <div
                  className={`dashboard-item ${
                    highlightedKeys.includes(item.key) ? "widget-highlight" : ""
                  }`}
                  style={{ position: "relative" }}
                >
                  {/* ✅ Drag Handle (Fixed) */}
                  {
                    // item.key !=='coach_summary' &&
                    <img
                      src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg"
                      alt="drag handle"
                      className="drag-handle"
                      draggable="true"
                      onMouseDown={handleMouseDown} // Prevents issues with image dragging
                      onDragStart={(e) => handleDragStart(e, item)}
                      style={{
                        position: "absolute",
                        top: item.key ==='coach_summary' ? "4px" : "30px",
                        left: "40px",
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                        zIndex: "10000",
                        opacity: "0",
                      }}
                    />
                  }

                  {/* {item.component} */}
                  {item.component ? React.cloneElement(item.component, { setLeftSections, setRightSections, compID: item.id, left: 1, tmpState: props.tmpState, setTmpState: props.setTmpState }) : null}

                  {/* ❌ Delete Icon */}
                  {/* <img
                    src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
                    alt="delete icon"
                    className="delete-icon"
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "30px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDelete(item.id, setLeftSections)}
                  /> */}
                </div>
              </Col>
            ))}
          </Row>
        </Col>

        <Col span={8}>
          <Row
            // gutter={[16, 16]}
            ref={rightContainerRef}
            className="rightside sortable-container"
          >
            {rightSections.map((item) => (
              <Col
                key={item.id}
                data-id={item.id}
                data-label={item.label}
                // span={item.span}
                span={24}
                data-key={item.key}
                className="rightside sortable-item"
                style={{
                  margin: "20px 0",
                }}
              >
                <div
                  className="dashboard-item"
                  style={{ position: "relative" }}
                >
                  {/* ✅ Drag Handle (Fixed) */}
                  {
                    // item.key !=='coach_summary' &&
                    <img
                      src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg"
                      alt="drag handle"
                      className="drag-handle"
                      draggable="true"
                      onMouseDown={handleMouseDown} // Prevents issues with image dragging
                      onDragStart={(e) => handleDragStart(e, item)}
                      style={{
                        position: "absolute",
                        top: item.key ==='coach_summary' ? "4px" : "30px",
                        left: "40px",
                        cursor: "pointer",
                        width: "20px",
                        height: "20px",
                        zIndex: "10000",
                        opacity: "0",
                      }}
                    />
                  }

                  {/* {item.component} */}
                  {item.component ? React.cloneElement(item.component, { setLeftSections, setRightSections, compID: item.id, left: 0, tmpState: props.tmpState, setTmpState: props.setTmpState }) : null}

                  {/* ❌ Delete Icon */}
                  {/* <img
                    src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
                    alt="delete icon"
                    className="delete-icon"
                    style={{
                      position: "absolute",
                      top: "10px",
                      right: "30px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleDelete(item.id, setRightSections)}
                  /> */}
                </div>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardComp;

